var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout optimised-stop-address-block" }, [
      _c("div", { staticClass: "md-layout-item" }, [
        _c("span", [_vm._v(_vm._s(_vm.content.address))]),
      ]),
    ]),
    _c("div", { staticClass: "md-layout md-alignment-center-space-between" }, [
      _c(
        "div",
        { staticClass: "md-layout-item md-size-60 stop-team-member-block" },
        [
          _c("span", { staticClass: "team-member-image" }, [
            _vm.content.photoUrl
              ? _c("img", {
                  staticClass: "profile-image",
                  attrs: { src: _vm.content.photoUrl, alt: "" },
                  on: { error: _vm.$_setDefaultBrokenImage },
                })
              : _c("img", {
                  staticClass: "member-image",
                  attrs: { src: _vm.$root.defaultPhotoUrl, alt: "" },
                }),
          ]),
          _c("span", { staticClass: "left-margin" }, [
            _vm._v(_vm._s(_vm.content.teamMemberName)),
          ]),
        ]
      ),
    ]),
    _c("table", { staticClass: "md-table" }, [
      _c(
        "tbody",
        [
          _c(
            "tr",
            [
              _c("th", { staticClass: "md-table-head" }),
              _c("th", { staticClass: "md-table-head" }, [_vm._v("Stop Ref")]),
              _c("th", { staticClass: "md-table-head stop-multi-address" }, [
                _vm._v("Name"),
              ]),
              _c("th", { staticClass: "md-table-head" }, [_vm._v("Phone")]),
              _vm.hasCapacitySettings("quantity", "volume", "weight")
                ? [
                    _vm.hasCapacitySettings("quantity")
                      ? _c(
                          "th",
                          { staticClass: "md-table-head" },
                          [
                            _c("md-icon", [
                              _c("img", {
                                staticClass: "capacity-images",
                                attrs: {
                                  src: "/img/icons/capacity-items-gray.png",
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasCapacitySettings("volume")
                      ? _c(
                          "th",
                          { staticClass: "md-table-head" },
                          [
                            _c("md-icon", [
                              _c("img", {
                                staticClass: "capacity-images",
                                attrs: {
                                  src: "/img/icons/capacity-volume-gray.png",
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.hasCapacitySettings("weight")
                      ? _c(
                          "th",
                          { staticClass: "md-table-head" },
                          [
                            _c("md-icon", [
                              _c("img", {
                                staticClass: "capacity-images",
                                attrs: {
                                  src: "/img/icons/capacity-weight-gray.png",
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.hasSkillsSettings() ? [_vm._m(0)] : _vm._e(),
              _vm.hasServiceSettings() ? [_vm._m(1)] : _vm._e(),
            ],
            2
          ),
          _vm._l(_vm.content.stopList, function (stop, index) {
            return _c(
              "tr",
              { key: index },
              [
                _c("td", { staticClass: "md-table-cell md-stop" }, [
                  _vm._v(_vm._s(stop.stopIndex)),
                ]),
                _c(
                  "td",
                  {
                    staticClass: "md-table-cell md-stop stop-ref-block",
                    on: {
                      click: function ($event) {
                        return _vm.showDetailsPage(stop)
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(stop.stopRef))])]
                ),
                _c(
                  "td",
                  { staticClass: "md-table-cell md-stop stop-multi-address" },
                  [_vm._v(_vm._s(stop.contact.name || "-"))]
                ),
                _c("td", { staticClass: "md-table-cell md-stop" }, [
                  _vm._v(_vm._s(stop.contact.phone || "-")),
                ]),
                _vm.hasCapacitySettings("quantity", "volume", "weight")
                  ? [
                      _vm.hasCapacitySettings("quantity")
                        ? _c("td", { staticClass: "md-table-cell md-stop" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getCapacityInfo(stop, "quantity", "items")
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm.hasCapacitySettings("volume")
                        ? _c("td", { staticClass: "md-table-cell md-stop" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getCapacityInfo(stop, "volume", "m3")
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm.hasCapacitySettings("weight")
                        ? _c("td", { staticClass: "md-table-cell md-stop" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getCapacityInfo(stop, "weight", "kg")
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm.hasSkillsSettings()
                  ? [
                      _c("td", { staticClass: "md-table-cell md-stop" }, [
                        _c("span", [_vm._v(_vm._s(_vm.getSkillsInfo(stop)))]),
                      ]),
                    ]
                  : _vm._e(),
                _vm.hasServiceSettings()
                  ? [
                      _c("td", { staticClass: "md-table-cell md-stop" }, [
                        _c("span", [_vm._v(_vm._s(_vm.getServiceInfo(stop)))]),
                      ]),
                    ]
                  : _vm._e(),
                _c("td", { staticClass: "md-table-cell md-stop" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-size-40 stop-button-block stop-multi-buttonclock",
                    },
                    [
                      _c("delete-stop-button", {
                        staticClass:
                          "info--buttons md-primary md-button md-just-icon md-round",
                        attrs: {
                          "stop-id": stop.stopId,
                          "vehicle-id": stop.vehicleId,
                          "allocate-stops": _vm.content.allocateStops,
                          "stop-ref": stop.stopRef,
                          address: stop.address,
                        },
                        on: { stopDeleted: _vm.handleDeleteStop },
                      }),
                      _c("reassign-stop-button", {
                        attrs: {
                          "team-members": _vm.content.teamMembers,
                          "allocate-stops": _vm.content.allocateStops,
                          "stop-id": stop.stopId,
                          "vehicle-id": stop.vehicleId,
                        },
                        on: { reassignedStop: _vm.handleReassignedStop },
                      }),
                      _vm.content.trackingLinkUrl
                        ? _c(
                            "md-button",
                            {
                              staticClass:
                                "info--buttons md-primary md-button md-just-icon md-round",
                              attrs: {
                                title: "tracking link",
                                "md-ripple": false,
                              },
                              on: { click: _vm.showTrackingLink },
                            },
                            [_c("md-icon", [_vm._v("directions_car")])],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              2
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "md-table-head" }, [
      _c("span", [_vm._v("Skills")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { staticClass: "md-table-head" }, [
      _c("span", [_vm._v("Services")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }